import {IManage} from './components/IManage'
import {PDFOptimizer} from "./dialogs/optimizer";
import {CombineFiles} from './dialogs/combineFiles'
import {MulFiles} from './dialogs/MulFiles'
import {CommonPanel} from './dialogs/commonPanel';
import {OpenFile} from './dialogs/openFile';
import {SaveFile} from './dialogs/saveFile';
import {html2pdf} from './dialogs/html2pdf';
import {ImportComment} from './dialogs/ImportComment';
import {AppendWebLinks} from './dialogs/AppendWebLinks';
import {EditViewWebLinks} from './dialogs/EditViewWebLinks';
import {TrustManager} from './dialogs/trustManager';
import {Preferences} from './dialogs/preferences';
import {watermark} from './dialogs/watermark';
import {background} from './dialogs/background';
import {headerfooter} from './dialogs/headerfooter';
import {batesNumbering} from './dialogs/batesNumbering';
import {DrivesListDlg} from './dialogs/drivesListDlg';
import {SignUp} from './dialogs/signUp'
import {shareDlg} from './dialogs/shareDlg'
import { SharePoint } from './dialogs/SharePoint'
import { collaboration } from './components/collaboration'
import { CollaborationOnline } from './components/collaboration_online'
import {Feedback} from './pages/feedback'
import {GetStartGuid} from './components/get_start_guid'
import {InsertBlankPage} from './components/insert_blank_page'
import {subscription} from './components/subscribe'
import {account} from './components/account'
import {activate} from './components/activate'
import {profile} from './components/profile'
import {Welcome} from './components/welcome'
import {Survey} from './components/survey'
import {FoxitPlugIns} from './components/foxit_plug_ins'
import {Notification} from './components/notification'
import {updateLogs} from './dialogs/updateLogs'
import {ResetForm} from './dialogs/form'
import {ExportMultiForms} from './dialogs/ExportMultiForms'
import { FoxitSign } from './components/FoxitSign'
import { Home } from './components/Home'
import { HeaderContainer } from './components/HeaderContainer'
import { esignTools } from './components/eSignChina/esignTools'
import { esignRecord } from './components/eSignChina/esignRecord'
import { AboutFoxit } from './dialogs/aboutFoxit'
import { ChoosePages } from './dialogs/choosePages';
import { EditBookmark } from './dialogs/editBookmark';
import { SaveAs } from './dialogs/saveAs';
import { SecurityPolicies } from './dialogs/SecurityPolicies';
import { ChooseFiles4Organize } from './dialogs/ChooseFiles4Organize';
import { ConvertToPDF } from './dialogs/convertToPDF';
import { AddDigitalID } from './dialogs/AddDigitalID';
import { PromptDigitalIDPassword } from './dialogs/PromptDigitalIDPassword';
import { PromptPassword } from './dialogs/PromptPassword';
import { DigitalIDs } from './dialogs/DigitalIDs';
import { CertificateProtect } from './dialogs/CertificateProtect';
import { OptionsForm } from './dialogs/optionsForm';
import { compareDialog } from './dialogs/compareDialog';
import { ColorPicker } from './dialogs/ColorPicker';
import {ScannedEditingSetting} from "./dialogs/scannedEditingSetting";
import {RecoginizeText} from "./dialogs/recoginizeText";
import { AiRecommend } from './components/AiRecommend'
import { ActionWizard } from './dialogs/actionWizard';
import { pageTransitionsDialog } from './dialogs/pageTransitions';
import { userEnv } from './dialogs/userEnv';
import { ConvertPreflight } from './dialogs/convertPreflight';
import EduGuidePopup from './dialogs/EduGuidePopup';
import { recordDialog } from './dialogs/eSignChina/record';
import { eSignChinaLegalNoticeDialog } from './dialogs/eSignChina/eSignChinaLegalNotice';
import {eSignChinaEvidenceTool} from './components/eSignChina/evidenceTool';
import { esignGalleryTool } from './components/eSignChina/gallery-tool';
import { noAccessStampAdminPermission } from './dialogs/eSignChina/noAccessStampAdminPermission'
import { pasteFieldConfirmDialog } from './dialogs/pasteFieldConfirmDialog';
import { SignatureListContainer } from './components/signatureListContainer'
import { eSignChinaUnite } from './dialogs/eSignChina/unite'
import { ESignAgreements } from './components/ESignAgreements';
import { MultiTabsBar } from './components/MultiTabsBar'
import { FoxitStorage } from './components/FoxitStorage'
import { PaperCheck } from './components/PaperCheck/PaperCheck';

const langImport = {
    HeaderContainer: HeaderContainer,
    IManage,
    Home: Home,
    AiRecommend: AiRecommend,
    shareDlg,
    SharePoint,
    collaboration,
    CollaborationOnline: CollaborationOnline,
    FoxitSign: FoxitSign,
    PDFOptimizer: PDFOptimizer,
    CombineFiles: CombineFiles,
    MulFiles:MulFiles,
    CommonPanel: CommonPanel,
    OpenFileForPanel: OpenFile,
    SaveFileForPanel: SaveFile,
    html2pdf: html2pdf,
    AppendWebLinks:AppendWebLinks,
    ImportComment:ImportComment,
    EditViewWebLinks:EditViewWebLinks,
    headerfooter:headerfooter,
    batesNumbering: batesNumbering,
    DrivesListDlg: DrivesListDlg,
    Welcome: Welcome,
    Survey: Survey,
    FoxitPlugIns: FoxitPlugIns,
    Notification:Notification,
    SignUp: SignUp,
    AboutFoxit: AboutFoxit,
    updateLogs: updateLogs,
    ResetForm: ResetForm,
    ExportMultiForms: ExportMultiForms,
    GetStartGuid: GetStartGuid,
    InsertBlankPage: InsertBlankPage,
    watermark:watermark,
    background:background,
    TrustManager: TrustManager,
    Preferences: Preferences,
    Feedback: Feedback,
    subscription: subscription,
    account: account,
    activate:activate,
    profile:profile,
    SaveAs: SaveAs,
    SecurityPolicies: SecurityPolicies,
    ChooseFiles4Organize: ChooseFiles4Organize,
    ChoosePages: ChoosePages,
    EditBookmark: EditBookmark,
    ConvertToPDF: ConvertToPDF,
    AddDigitalID,
    PromptDigitalIDPassword,
    PromptPassword,
    DigitalIDs,
    CertificateProtect,
    OptionsForm: OptionsForm,
    compareDialog,
    ColorPicker: ColorPicker,
    ScannedEditingSetting: ScannedEditingSetting,
    RecoginizeText: RecoginizeText,
    ActionWizard,
    userEnv: userEnv,
    pageTransitionsDialog,
    EduGuidePopup,
    ConvertPreflight,
    recordDialog,
    esignTools,
    esignRecord,
    eSignChinaLegalNoticeDialog,
    eSignChinaEvidenceTool,
    esignGalleryTool,
    pasteFieldConfirmDialog,
    SignatureListContainer,
    eSignChinaUnite,
    noAccessStampAdminPermission,
    ESignAgreements,
    MultiTabsBar,
    FoxitStorage,
    PaperCheck
}

let lang = {
  "ConvertPopup":{
    "title":"Convert to PDF",
    "tabTitle": "Choose files",
    "tabFirst":"From Files",
    "tabSec":"From Web Page ",
    "tabThird":"From Clipboard",
    "fourThird":"Create PDF Portfolio",
    "start":"Start",
    "webDes":"Create a PDF from content on the web pages",
    "ClipboardDes":"Create a PDF from content on the clipboard",
    "chooseFile":"Choose File",
    "chooseDes":"Choose from docx, xlsx, txt, etc.",
    "portfolioBtn1":"Create a new PDF Portfolio",
    "portfolioBtn2":"Create a blank PDF Portfolio",
    "portfolioDes":"Aggregate and organize multiple types of files into a PDF package"
   },
  "Combine": "combine",
  "Portfolio": "Portfolio",
  "RestrictDownload": "Restrict download of this content",
  "BottomAd.MoreFeature": "Looking for more features? Give our powerful desktop version a try. ",
  "BottomAd.FreeTrial": "Free trial",
  "PhantomPDF.Online.AppTitle": "Foxit PDF Editor Cloud - Edit PDF",
  "PhantomPDF.Online.AppTitleForXX": "Foxit PDF Editor Cloud for {name}",
  "PhantomPDF.Online": "Foxit PDF Editor Cloud",
  "PhantomPDF.Online.Title": "PDF Editor Cloud",
  "PhantomPDF.Online.TitleWithOnline": "Foxit PDF Editor Cloud",
  "PhantomPDF.Online.Online": " Online",
  "dialog.beforeShow": "After applying, you won't be able to modify it in Foxit PDF Editor Cloud. You can modify the original file or use Foxit PDF Editor for Windows/Mac to modify.",
  "DoNotShowAgain": "Don't show again",
  "GoogleDrivePermissionError": "You don't have sufficient permissions for this file.",
  "NoData": "No data",
  "DropFileHere": "Drag and drop a PDF file here to open it.",
  "DropFileToConvert": "To convert a file to PDF, go to Convert -> From Files.",
  "success": "success",
  "failed": "failed",
  "Ok": "OK",
  "No": "No",
  "Yes": "Yes",
  "Cancel": "Cancel",
  "Close": "Close",
  "logBackIn": "log back in",
  "Add": "Add",
  "FileNotExist": "File does not exist",
  "Edit": "Edit",
  "Clear": "Clear",
  "AddFiles": "Add Files",
  "NetworkError": "Network error",
  "Subscribe": "Subscribe",
  "SubscribeNow": "Subscribe now",
  "DownloadDesktop": "Download desktop version",
  "ThanksGotIt": "Thanks, got it",
  "ALL": "ALL",
  "AutoLogin": "Verifying your account status...",
  "user.helloSomeone": "Hello, {name}",
  "user.toAdminConsole": "Admin Console",
  "user.signIn": "Sign In",
  "user.signUp": "Sign Up",
  "user.myAccount": "My Account",
  "user.signInWaiting": "Please complete the Sign In process in another browser tab.",
  "user.signUpWaiting": "Please complete the Sign Up process in another browser tab.",
  "user.signOut": "Sign Out",
  "user.policy": "Privacy Policy",
  "user.terms": "Terms of Service",
  "Error.NoLicense": "No license, please contact your Office 365 administrator for assistance.",
  "Error.SignOutAndRetry": "Please sign out and log back into your account.",
  "Error.PermissionDenied": "Your current account doesn't have access to this file. Please log in with another account.",
  "DisableJS.Warning": "JavaScript is disabled, and this document includes JavaScript. If you trust this document, you can re-enable JavaScript in File -> Trust Manager",
  "SafeMode.SubmitWarning": "The document is trying to submit form data to an external address. Do you want to continue?",
  "NotSupportSign": "The Sign feature hasn't been supported yet!",
  "InvalidToken": "Invalid token",
  "InsufficientSpace": "Insufficient space",
  "AbandonRequest": "Click OK to cancel the request",
  "SaveFilePending": "The file is still being saved, are you sure you want to exit?",
  "AbandonSaveFile": "Click Cancel to cancel saving",
  "OpenFilePending": "The file is still being opened, are you sure you want to cancel?",
  "Support":"Support",
  "AbandonOpenFile": "Click Yes to cancel opening",
  "CancelRequest": "Cancel Request",
  "Drives.GoogleDriveLoadFailed": "Could not load from Google Drive. Please try again later.",
  "Private.duplicateFileNameContent": "The file {FileName} already exists, do you want to replace it?",
  "Private.duplicateFileNameTitle": "This file name already exists.",
  "PrivateDrive.FileNameRequire": "Please input the file name",
  "PrivateDrive.FileName": "File name: ",
  "PrivateDrive.AlreadySignIn": "Already logged in",
  "PrivateDrive.Status": "Status",
  "PrivateDrive.Resume": "Resume",
  "PrivateDrive.ChangHost": "Change host",
  "PrivateDrive.signOut": "Sign Out",
  "PrivateDrive.Connect": "Connect",
  "UploadingFile": "Uploading file...",
  "UploadingFile.info": "You can access this file after it has finished uploading.",
  "UploadingFile.success": "File upload succeeded",
  "UploadingFile.fail": "File upload failed",
  "submit.suc":"File successfully submitted!",
  "submit.fail":"File submit failed!",
  "unSubmit.suc":"File successfully unsubmitted!",
  "unSubmit.fail":"Failed to unsubmit file!",
  "lmssubedTipTitle":"File has been submitted",
  "lmssubedTip":"Please unsubmit the file before editing",
  "lmsunsubmit":"Unsubmit",
  "pleaseNote":"Please Note",
  "fileStateChange":"Your assignment's state has been changed. Please reload your page first.",
  "fileMissTitle":"File is missing",
  "fileMissTip":'File in {drive} were deleted or moved. Please contact the course teacher.',
  "fileMissTipTeacher":"Files in {drive} were deleted or moved. Please recreate an assignment.",
  "suggestionTitle":"Suggestion",
  "suggestionTip":"This file has been used in the course: {course}. Any edits and annotations will be included in your students\' individual copies, it is recommended not to add answers to this file.",
  "suggestionNoShow":"Don't show again",
  "UpdatingFile": "Updating file...",
  "Initialize":"Initializing...",
  "Loading.file":"Loading...",
  "SaveFile.auto": "Auto saving",
  "SavingFile": "Uploading...",
  "SaveFile.success": "File saved succeeded",
  "SaveFile.fail": "File saved failed",
  "FileOverSize": "The size of the file can't be greater than 50 MB",
  "UpdatingFile.info": "You can access this file after it has finished updating.",
  "UpdatingFile.success": "File update successful",
  "UpdatingFile.fail": "File update failed",
  "SignInToYour": "Sign in to your {DriveName} to access your documents",
  "SignInTo": "Sign in to {DriveName}",
  "OpenFile": "Open File",
  "SaveFile": "Save File",
  "SelectHost": "Select a host",
  "SelectHostFirst": "Please select a host first",
  "ConnectingToSMB": "Connecting to SMB storage",
  "ConnectingToS3": "Connecting to Amazon S3 storage",
  "ConnectingToNFS": "Connecting to NFS storage",
  "NoneStorage": "None",
  "Save": "Save",
  "Open": "Open",
  "SharePointLoginFailed": "SharePoint login failed",
  "FileHandlerStateIdExpired": "The document link has expired",
  "DocExist": "The document already exists.",
  "IllegalParams": "Illegal parameters",
  "InvalidPublicKey": "Invalid public key. Please sign in again.",
  "UnKnownError": "Unknown error. Please try again later.",
  "UnKnownUserNameOrPassword": "Incorrect username or password.",
  "PleaseInputYourPassword": "Please input your password",
  "PleaseInputYourUserName": "Please input your username",
  "FileName": "File",
  "FileSize": "Size",
  "ModifyTime": "Date modified",
  "Host": "Host",
  "Share": "Share",
  "UserName": "Username",
  "Password": "Password",
  "Connect": "Connect",
  "SMBStorage": "SMB Storage",
  "S3Storage": "Amazon S3 Storage",
  "NFSStorage": "NFS Storage",
  "Permission.SignIn": "Please sign in to your account to continue.",
  "Permission.SignIn.Convert": "Please sign in to your account to continue.",
  "Uploading": "Uploading...",
  "File.ToDo": "The file will be opened. Do you want to save your current file first?",
  "File.ToStopOpen": "Do you want to save changes to \"{FileName}\" before leaving?",
  "File.ToStopOpenTemplate": "The new file will be opened, do you want to save the current file?",
  "File.ToStopOpenTemplate.Title": "Save the current file?",
  "File.GoTOSave": "Save",
  "Convert.Title": "Convert File",
  "Converting": "Converting...",
  "Converting.info.ToPDF": "The converted file will be opened after conversion.",
  "Converting.info": "The converted file will be downloaded after conversion",
  "Convert.success.title": "Converted successfully",
  "Convert.success.info": "Downloading file...",
  "Convert.success.ToPDF.info": "Your file has been converted.",
  "Convert.failed": "Conversion failed.",
  "Convert.Limit": "The size of this document is greater than 10MB, it may take longer than usual to convert. Do you want to continue?",
  "Convert.ToDo": "The converted file will be opened. Do you want to save the current file and continue?",
  "Convert.ToDoAndNext": "Save & Open",
  "Convert.ToNext": "Open directly",
  "Convert.BrowserNotSupport": "Your browser not support reading clipboard data.",
  "Convert.SecureContext": "Access clipboard data requires a secure origin, either HTTPS or localhost.",
  "Convert.NoDataAtClipboard": "No valid data on clipboard.",
  "Convert.ExportAllImages.Fail": "Foxit PDF Editor could not extract any images from this document, only images that contain bitmap or raster data can be extracted.",
  "SaveTo.Title": "Save To",
  "Local Computer": "Local Computer",
  "OneDrive": "OneDrive",
  "Box": "Box",
  "Dropbox": "Dropbox",
  "Google Drive": "Google Drive",
  "SaveTo.Content": "Your document has been converted. Choose a location to save it in.",
  "NotSupportedFormat": "This file format is not supported.",
  "InvalidURL": "Invalid URL. Please enter again.",
  "file.save.drive": "Your file has been saved.",
  "PDF2Img.Title": "PDF to JPG",
  "PDF2Img.Content": "Set the image resolution: ",
  "PDF2Img.DPI_72": "Minimum quality (72 dpi)",
  "PDF2Img.DPI_96": "Low quality (96 dpi)",
  "PDF2Img.DPI_150": "Medium quality (150 dpi)",
  "PDF2Img.DPI_300": "High quality (300 dpi)",
  "PDF2Img.DPI_600": "Maximum quality (600 dpi)",
  "PDF2Img.FailConvert": "Failed to convert the PDF to an image.",
  "PDF2Img.LimitPageSize": "The file is too large to convert. The maximum file size is 50 MB.",
  "PDF2Img.Success": "Your file has been converted into an image file successfully.",
  "PDF2Img.Cancel": "Cancel",
  "PDF2Img.Convert": "Convert",
  "PDF2Img.Tip": "Convert PDF file to JPG image file.",
  "PDF2Img.progressTitle": "PDF to JPG",
  "PDF2Img.progressStatus": "Converting...",
  "ExportAllImg.Tip": "Export all images in the document",
  "ExportAllImg.Title": "Export All Images",
  "ExportAllImg.SwitchTip": "Export images from which pages?",
  "ExportAllImg.CurPage": "Current page",
  "ExportAllImg.AllPage": "All pages",
  "ExportAllImg.PageFrom": "Page From",
  "ExportAllImg.to": "To",
  "ExportAllImg.of": "of",
  "ExportAllImg.OK": "Export Images",
  "ExportAllImg.Cancel": "Cancel",
  "ExportAllImg.progressTitle": "Export All Images",
  "ExportAllImg.progressStatus": "Exporting...",
  "ExportAllImg.FailConvert": "Failed to export images.",
  "ExportAllImg.LimitPageSize": "The file is too large to convert. The maximum file size is 50 MB.",
  "ExportAllImg.Success": "Images exported successfully.",
  "Flatten.Title": "Flatten page",
  "Flatten.CurPage": "Current page",
  "Flatten.AllPage": "All pages",
  "Flatten.PageFrom": "Page From",
  "Flatten.to": "To",
  "Flatten.of": "of",
  "Error.Notagged": "Exporting comments to a Word document will only work when the PDF document is a tagged pdf, in which all the contents are tagged.<br/><br/>To ensure the created tagged PDF document can normally work with this feature, you can create a tagged PDF document from the original Word document.<br/><br/>To create a tagged PDF document in Word, you can select \"Advanced\" from the \"Foxit PDF\" ribbon, check the box labeled \"Tagged PDF\".",
  "Error.offline": "Cannot connect to the network, please try again later.",
  "Error.OpenFile": "Format error: Not a PDF or corrupted",
  "Error.noLinks": "There are no links to the web on this page",
  "Error.TimesLimit": "You have reached the limit for advanced features for this time. Please try again after {RemainingTime}.You can subscribe to {FoxitEU} Edition now to enjoy a pleasant PDF experience on all platforms.Or you can also download the desktop version, which offers a 14-day free trail without limitation.",
  "Error.OpenURLFile": "This file cannot be opened. Please download it and open it from your local computer.",
  "Error:404": "PDF Editor Cloud is currently unavailable. Please try again later.",
  "Error.100010": "Your credentials have expired. Please sign in again.",
  "Error.FileLimit": "The file is too large to convert. The maximum file size is ({FileLimit}).",
  "Error.Unknown": "Unknown error occurred, please try again later.",
  "Error.80000001": "Failed to initialize the tool.",
  "Error.80000002": "Failed to upload the document to the server.",
  "Error.80000003": "This file is not the correct format",
  "Error.80000004": "Settings error.",
  "Error.80000005": "Creating a directory failed in the server.",
  "Error.80000006": "File path error.",
  "Error.81000000": "Unknown error.",
  "Error.81000001": "This document is encrypted.",
  "Error.81000002": "This file is already a Connected PDF document.",
  "Error.81000003": "Failed to add the navigation layer.",
  "Error.81000004": "Failed to save the Connected PDF document.",
  "Error.81000005": "Image file format error.",
  "Error.81000006": "Failed to parse the image.",
  "Error.81000007": "Failed to load the image.",
  "Error.81000008": "No effective frame in this image file.",
  "Error.81000009": "Failed to convert the objects of the document.",
  "Error.81000011": "Failed to optimize the document.",
  "Error.81000012": "This document is encrypted with DRM.",
  "Error.81000014": "Failed to add a watermark.",
  "Error.81000015": "This file is encrypted.",
  "Error.81000016": "Failed to organize the PDF file.",
  "Error.81000017": "This file is encrypted.",
  "Error.81000019": "This file is encrypted.",
  "Error.81000020": "Conversion failed.",
  "Error.81000021": "This file is encrypted.",
  "Error.81000022": "Conversion failed.",
  "Error.81000023": "This file is encrypted.",
  "Error.81000024": "Failed to add a password.",
  "Error.81000025": "This file is encrypted.",
  "Error.81000026": "PDF redaction failed.",
  "Error.81000027": "No redaction marks on this document.",
  "Error.81000028": "This file is encrypted.",
  "Error.81000029": "Failed to add header & footer.",
  "Error.81000030": "This file is encrypted.",
  "Error.81000031": "Failed to rotate PDF page(s).",
  "Error.81000032": "This file is encrypted.",
  "Error.81000033": "Conversion failed.",
  "Error.81000034": "XFA files are currently not supported.",
  "Error.81000035": "This document does not contain any text.",
  "Error.81000036": "This file is encrypted.",
  "Error.81000037": "Failed to split PDF.",
  "Error.81000038": "This file is encrypted.",
  "Error.81000039": "Failed to split PDF.",
  "Error.81000040": "This file is encrypted.",
  "Error.81000041": "Conversion failed.",
  "Error.81000042": "Failed to organize the PDF file.",
  "Error.81000043": "This file is encrypted.",
  "Error.81000044": "Conversion failed.",
  "Error.81000045": "This file is encrypted.",
  "Error.81000046": "Failed to flatten PDF.",
  "Error.81000047": "This file is encrypted.",
  "Error.81000048": "XFA files are currently not supported.",
  "Error.81000049": "Conversion failed.",
  "Error.81000050": "Conversion failed.",
  "Error.81000051": "This document does not have any images.",
  "Error.81000052": "Invalid settings.",
  "Error.86000060": "This file is protected with DRM. Please sign in to continue.",
  "Error.86000061": "This file is protected with DRM. You do not have permission.",
  "Error.87000001": "Response timeout.",
  "Error.87000002": "Program error.",
  "Error.87000003": "Conversion failed.",
  "Error.87000005": "The file is corrupted.",
  "Error.87000008": "Invalid page range setting.",
  "Error.87000009": "Not enough memory available.",
  "Error.87000010": "The file has copy protection.",
  "Error.87000011": "This file is encrypted.",
  "Error.87000012": "Certificate error.",
  "Error.87000015": "No tables were contained in this PDF document.",
  "Error.87000016": "No images were contained in this PDF document.",
  "Error.87000020": "PDF/A files are not currently supported.",
  "Error.87000021": "PDF/A files are not currently supported.",
  "Error.87000030": "The process is already loaded.",
  "Error.87000031": "Incorrect password.",
  "Error.87000032": "This file is encrypted and you are not the owner.",
  "Error.87000033": "This file is encrypted and you are not the owner.",
  "Error.87000034": "This file is encrypted and you are not the owner.",
  "Error.87000035": "This file is encrypted and you are not the owner.",
  "Error.87000036": "Invalid certificate.",
  "Error.87000200": "Unknown error.",
  "Error.82000006": "Invalid settings.",
  "Error.82000007": "OCR failed.",
  "PermissionError": "Permission error",
  "FileOverSizeCommon": "The size of the file can't be greater than {fileSize} MB",
  "sidebar": {
    "comments": {
      "show": "Show all comments",
      "hide": "Hide all comments"
    }
  },
  "toolbar": {
    "tabs": {
      "home": {
        "title": "Home"
      },
      "file": {
        "title": "File"
      },
      "convert": {
        "title": "Convert"
      },
      "edit": {
        "title": "Edit"
      },
      "organize": {
        "title": "Organize"
      },
      "comment": {
        "title": "Comment"
      },
      "view": {
        "title": "View"
      },
      "form": {
        "title": "Form"
      },
      "protect": {
        "title": "Protect"
      },
      "help": {
        "title": "Help"
      },
      "fillAndSign": {
        "title": "Foxit Sign"
      },
      "compareResult": {
        "title": "Compare Results"
      },
      "foxitESign": {
        "title": "Foxit eSign"
      },
      "foxitESignToolTip": {
        "tipHeader": "Foxit eSign",
        "tipContent": "Foxit eSign provides legally-binding electronic signature services."
      }
    },
    "form": {
      "resetForm": {
        "title": "Reset Form",
        "tooltip": "Reset all form fields to their default values"
      },
      "combineForms": {
        "title": "Combine Forms to a Sheet ",
        "tooltip": "Combine forms and export data to a sheet "
      },
      "addTooltip": {
        "title": "Add Tooltip",
        "tooltip": "Add tooltips for all form fields which do not have descriptions."
      }
    },
    "help": {
      "feedback": {
        "title": "Share feedback",
        "tooltip": "Report an error or send us a suggestion"
      },
      "foxitSoftware": {
        "title": "About",
        "tooltip": "Learn more about Foxit Software"
      },
      "eduExclusive": {
        "title": "Education Exclusive",
        "tooltip": "More product and services for education users"
      },
      "helpCenter": {
        "title": "Help Center",
        "tooltip": "Open our Help Center to view topics"
      },
      "updateLogs": {
        "title": "What's New",
        "tooltip": "What's New"
      },
      "downloadClient": {
        "title": "Download Foxit PDF Editor",
        "tooltip": "Download desktop version for advanced editing"
      },
      "downloadClientCN": {
        "title": "Get more editing features",
        "tooltip": "Download Foxit PDF Editor for more advanced features"
      },
      "foxitPlugIns": {
        "title": "Foxit Plug-ins",
        "tooltip": "Open the plug-in store and install the plug-in to help work"
      }
    },
    "fillAndSign": {
      "RequestSignature": {
        "title": "Request Signatures",
        "tooltip": "Request Signatures",
        "tooltipDes": "Send PDFs to others to sign online"
      },
      "AgreementStatus": {
        "title": "Document Status",
        "tooltip": "Document Status"
      },
      "ManageSignature": {
        "title": "Manage Signatures",
        "tooltip": "Manage Signatures",
        "tooltipDes": "Modify Signature style"
      },
      "ApplyAllSignature": {
        "title": "Apply All Signatures",
        "tooltip": "Apply All Signatures",
        "tooltipDes": "Apply all signatures to documents",
        "tipContent": "Please click \"Apply all signatures\" to complete the signing process. "
      },
      "DocumentStatus": {
        "title": "Document Status",
        "tooltip": "Document Status",
        "tooltipDes": "Track and review Recipient and Document status",
        "iframeTitle": "Document Signature"
      },
      "CloseSign": {
        "title": "Close",
        "tooltip": "Close"
      },
      "PDFSign": {
        "title": "Fill& Sign",
        "tooltip": "Fill out the flat form or sign the document with a picture signature"
      },
      "SwitchAccounts": {
        "title": "Switch Accounts",
        "tooltip": "Switch Accounts"
      }
    },
    "protect": {
      "secureDocument": "Secure Document",
      "certificateProtect": "Certificate Protect",
      "securityPolicies": "Security Policies",
      "securityProperties": "Security Properties",
      "redact_search": "Search & Redact",
      "apply": "Apply Redaction",
      "signCertify": "Sign & Certify",
      "digitalIDs": "Digital IDs"
    },
    "organize": {
      "extract": {
        "title": "Extract",
        "tooltip": "Extract Pages"
      },
      "split": {
        "title": "Split"
      },
      "flatten": {
        "title": "Flatten"
      },
      "watermark": {
        "title": "Watermark"
      },
      "watermarkAdd": {
        "title": "Add",
        "tooltip": "Add"
      },
      "watermarkUpdate": {
        "title": "Update",
        "tooltip": "Update"
      },
      "watermarkRemoveAll": {
        "title": "Remove All",
        "tooltip": "Remove All"
      },
      "background": {
        "title": "Background"
      },
      "backgroundAdd": {
        "title": "Add",
        "tooltip": "Add"
      },
      "backgroundUpdate": {
        "title": "Update",
        "tooltip": "Update"
      },
      "backgroundRemoveAll": {
        "title": "Remove All",
        "tooltip": "Remove All"
      },
      "headerfooter": {
        "title": "Header & Footer"
      },
      "headerfooterAdd": {
        "title": "Add",
        "tooltip": "Add"
      },
      "headerfooterUpdate": {
        "title": "Update",
        "tooltip": "Update"
      },
      "headerfooterRemoveAll": {
        "title": "Remove All",
        "tooltip": "Remove All"
      },
      "batesNumbering": {
        "title": "Bates Numbering"
      },
      "pageInsert": {
        "title": "Insert Blank Page",
        "tooltip": "Insert one or more blank pages"
      },
      "pageDelete": {
        "title": "Delete",
        "tooltip": "Delete specified pages"
      },
      "pageRotate": {
        "title": "Rotate",
        "tooltip": "Rotate Pages"
      },
      "pageRotateLeft": {
        "title": "Left",
        "tooltip": "Counterclockwise rotation for current page"
      },
      "pageRotateRight": {
        "title": "Right",
        "tooltip": "Clockwise rotation for current page"
      },
      "pageRotateMultiple": {
        "title": "Multi-page Rotate",
        "tooltip": "Rotate multiple pages one time"
      }
    },
    "file": {
      "preferences": {
        "title": "Preferences"
      },
      "trustmanager": {
        "title": "Trust Manager"
      },
      "properties": {
        "title": "File Properties"
      },
      "optimizer": {
        "title": "PDF Optimizer"
      },
      "advancedoptimization": {
        "title": "Advanced Optimization"
      },
      "reducesize": {
        "title": "Reduce File Size"
      },
      "scanned": {
        "title": "Optimize Scanned PDF"
      }
    },
    "buttons": {
      "loupe": "Loupe",
      "marquee": "Marquee",
      "print": "Print",
      "drawingTools": "Drawing Tools",
      "fromfiles": "From Files",
      "createPortfolio": "PDF Portfolio",
      "toOffice": "To MS Office",
      "toImage": "To Image",
      "otherToPdf": "From Files",
      "toOther": "To Other",
      "openFile": "Open File",
      "openLocalFile": "Local File",
      "openFromGoogleDrive": "Google Drive",
      "openFromImanage": "iManage 10",
      "openFromOneDrive": "OneDrive",
      "documents": "Cloud Documents",
      "recentFiles": "Recent Files",
      "openFromBox": "Box",
      "openFromDropBox": "Dropbox",
      "openFromDrives": "Open from Drive",
      "openFromPrivateDrive": "Open Private Storage",
      "openFromPrivateDriveS3": "Open AWS S3",
      "openFromPrivateDriveNFS": "Open NFS",
      "saveFile": "Save File",
      "saveAs": "Save As",
      "saveToLocal": "Save to Local Computer",
      "saveASFile": "Save As",
      "saveASFileCNArea": "Save As",
      "saveToGoogleDrive": "Save to Google Drive",
      "saveToImanage": "Save to iManage 10",
      "saveToOneDrive": "Save to OneDrive",
      "saveToDropBox": "Save to Dropbox",
      "saveToDrives": "Save to Drive",
      "saveToBox": "Save to Box",
      "saveToPrivateDrive": "Save to Private Storage",
      "saveToPrivateDriveS3": "Save to AWS S3",
      "saveToPrivateDriveNFS": "Save to NFS",
      "actionWizard": "Action Wizard",
      "createNewAction": "Create New Action",
      "manageActions": "Manage Actions",
      "runAction": "Run Action",
      "saveToFoxitStorage": "Save to Cloud Documents"
    },
    "convert": {
      "files2pdf": {
        "title": "From Files"
      },
      "filemultiple2pdf": {
        "title":"From Multiple Files"
      },
      "toPdfSettings": {
        "title": "Convert To PDF Settings"
      },
      "createBlankPdf":{
        "title": "Blank"
      },
      "clipboard2Pdf": {
        "title": "From Clipboard"
      },
      "html2pdf": {
        "title": "From Web Page"
      },
      "fromtemplate": {
        "title": "From Template"
      },
      "newPortfolio": {
        "title": "Create a new PDF Portfolio"
      },
      "blankPortfolio": {
        "title": "Create a blank PDF Portfolio"
      },
      "combinefiles": {
        "title": "Combine Files"
      },
      "exportimages": {
        "title": "Export All Images"
      },
      "pdf2word": {
        "title": "To Word"
      },
      "pdf2xmlspreadsheet2003":{
        "title": "To XML Spreadsheet 2003"
      },
      "pdf2word2003": {
        "title": "To Word 97-2003"
      },
      "pdf2excel": {
        "title": "To Excel"
      },
      "pdf2ppt": {
        "title": "To PowerPoint"
      },
      "pdf2png": {
        "title": "PNG..."
      },
      "pdf2jpeg": {
        "title": "JPEG..."
      },
      "pdf2jpeg2000": {
        "title": "JPEG2000..."
      },
      "pdf2tiff": {
        "title": "TIFF..."
      },
      "pdf2stardardxml":{
        "title": "To XML 1.0"
      },
      "pdf2bmp": {
        "title": "BMP..."
      },
      "pdf2rtf": {
        "title": "To Rich Text"
      },
      "pdf2txt": {
        "title": "To Plain Text"
      },
      "pdf2accessibletxt": {
        "title": "To Accessible Text"
      },
      "pdf2html": {
        "title": "To HTML"
      },
      "ocrquickrecognition": {
        "title": "Quick Recognition"
      },
      "preflight": {
        "title": "Preflight"
      }
    },
    "tooltip": {
      "firstPage": "First Page",
      "lastPage": "Last Page",
      "fullScreen": "Full Screen",
      "rotateLeft": "Rotate Left",
      "rotateRight": "Rotate Right",
      "previousView": "Previous View",
      "nextView": "Next View",
      "messageDesk": "Messaging Helpdesk",
      "chatAI": "AI Assistant",
      "pin": "Cancel Floating",
      "unPin": "Floating",
      "fitWidth": "Fit Width"
    },
    "error": {
      "fileOpen": {
        "err": "Open file error",
        "errWithFormat":"Format Error: Not a PDF or corrupted.",
        "errWithHandler":"This document is encrypted by some unsupported security handler. ",
        "errWithDownload":"File could not be downloaded.",
        "failed": "Open file failed"
      }
    }
  },
  "autoRedaction": {
    "dropdown": "Auto Redaction",
    "apply": {
      "msg": "You have decided to redact the keywords you selected. Once clicking OK, the operation cannot be undone; otherwise, click Cancel to review again.",
      "title": "Auto Mark for Redaction"
    }
  },
  "teamsApp": {
    "downLoadingFile": "Downloading your PDF file...",
    "collaborationRestricted": "The collaboration feature has been restricted due to data protection. Please ensure that the accounts of all collaborators share the same regional affiliation."
  },
  "esign":{
    "guideTitle":"Foxit eSign Service",
    "guideContent":"Welcome to use Foxit eSign Service, Foxit will provide and all-in-one and smooth signing journey."
  },
  "openServerModeOfClientInSafariErrorTip": "Open file failed. Safari does not support this app. ",
  "quickRecognition": {
    "alert": {
      "content": "Foxit PDF Editor could not perform recognition because this page contains renderable text or this page is blank.",
      "againText": "Ignore future errors in this document"
    }
  }
};
lang = Object.assign(lang, langImport);
export default lang;
